import { JSX } from 'react';
import {
    Edit,
    TabbedForm,
    TextInput,
    PasswordInput,
    required,
    ImageInput,
    ImageField,
    usePermissions,
    SelectInput,
    useRecordContext,
    useUpdate, UseGetIdentityResult, useGetIdentity, useNotify,
    ReferenceInput,
} from 'react-admin';
import {
    LinearProgress,
} from '@mui/material';
import { permissionManager } from "../permissions/manager";
import { AdminUser } from "../../types/entities";

const EditFormContainer: () => JSX.Element = (): JSX.Element => {
    const { id } = JSON.parse(localStorage.getItem('profile'));
    const { permissions } = usePermissions();
    const [update] = useUpdate();
    const record: AdminUser = useRecordContext();
    const idCard: UseGetIdentityResult = useGetIdentity();
    const notify: any = useNotify();

    /**
     * Validate the username and password if the fields are edited
     * @param values
     * @returns {{}}
     */
    const validateForm: (values: any) => any = (values: any): any => {
        const errors: any = {};
        if (typeof values['new_password'] !== "undefined" &&
            typeof values['repeat_new_password'] !== "undefined" &&
            typeof values['your_password'] !== "undefined" &&
            values['new_password'] !== values['repeat_new_password']) {
            errors.new_password = {
                message: "Your new passwords doesn't match, please make sure they match",
                args: {}
            };
            errors.repeat_new_password = {
                message: "Your new passwords doesn't match, please make sure they match",
                args: {}
            };
        }
        return errors;
    }

    function handleSave(values: any): void {
        // debugger;
        if (id === record.id) {
            values.profile_edit = 1;
        } else {
            values.user_edit = 1;
        }
        if (record) {
            update(
                'admin_users',
                { id: record.id, data: values, previousData: record },
                {
                    onSuccess: async (data: any): Promise<void> => {
                        if (id === record.id) {
                            idCard.identity.avatar = data['avatar'];
                            idCard.identity.fullName = data['username'];
                            // await refetch(); //reload the record
                            await idCard.refetch(); //reload the identity
                            notify("Your Profile has been updated", { type: "success" });
                        } else {
                            notify("Admin User Successfully Updated!", { type: "success" });
                        }

                    },
                    onError: (error: any): void => {
                        // HQAPI-73. The provider used to reject with nothing, so `error.message`
                        // read undefined and every failure said "Failed to update error:
                        // undefined". It now rejects with an HttpError carrying the API's
                        // hydra:description - a refused password change is a 422 and says why -
                        // and this still has to cope with a rejection that carries no message.
                        const reason: string = error?.message ?? 'The change was not saved';
                        notify(`Failed to update: ${reason}`, { type: 'error' });
                    },
                }
            );
        } else {
            console.log('aosijd')
        }
    }

    return (
        <TabbedForm onSubmit={ handleSave }  validate={ validateForm }>
            <TabbedForm.Tab label="Profile">
                <TextInput name="name" source="username" validate={[required()]} fullWidth />
                <TextInput name="email" source="email" validate={[required()]} fullWidth autoComplete="email" />
                { (id === record.id) &&
                    <ImageInput name="avatar" source="avatar" label="Avatar" accept={{ 'image/*': ['.jpg', '.png', '.gif', '.jpeg'] }}>
                        <ImageField source="src" title="title" />
                    </ImageInput>
                }
                { (id !== record.id) &&
                    <>
                        { permissionManager.isAllowed(permissions, 'HQ_Admin::admin_users.edit')  &&
                            <ImageInput name="avatar" source="avatar" label="Avatar" accept={{ 'image/*': ['.jpg', '.png', '.gif', '.jpeg'] }}>
                                <ImageField source="src" title="title" />
                            </ImageInput>
                        }
                        { (permissionManager.isAllowed(permissions, 'HQ_Admin::admin_users.edit'))  &&
                            <ImageField source="avatar.src" title="title" />
                        }
                    </>
                }

            </TabbedForm.Tab>
            { permissionManager.isAllowed(permissions, 'HQ_Admin::admin_users.edit')  &&
                <TabbedForm.Tab label="Roles">
                    {/* The ACL role, and the only thing on this tab since Stage 5. The legacy
                        `ROLE_*` select that stood here wrote a column HQ-API no longer authorises
                        on and no longer accepts, so it would have looked like a control and done
                        nothing. Assigned here rather than on the role screen, because the role
                        screen says what a role can do and this says who holds it. */}
                    <ReferenceInput source="role" reference="admin_roles">
                        <SelectInput
                            label="Access role"
                            optionText="name"
                            helperText="What this admin may reach in HQ. Managed under Admin Roles."
                        />
                    </ReferenceInput>
                </TabbedForm.Tab>
            }
            { (permissionManager.isAllowed(permissions, 'HQ_Admin::admin_users.edit') || id === record.id) &&
                <TabbedForm.Tab label="Password">
                    <PasswordInput name="new_password" source="new_password" fullWidth autoComplete="new-password" />
                    <PasswordInput name="repeat_new_password" source="repeat_new_password" fullWidth autoComplete="new-password" />
                    <PasswordInput name="your_password" source="your_password" fullWidth autoComplete="current-password" />
                </TabbedForm.Tab>
            }

        </TabbedForm>
    );
}


export const AdminUserEdit: () => JSX.Element = (): JSX.Element => {
    return (
        <Edit>
            <EditFormContainer />
        </Edit>
    );
}